var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.979 279.59H296.023L256 192.451L215.979 279.59ZM256 16C123.451 16 16 123.451 16 256S123.451 496 256 496S496 388.549 496 256S388.549 16 256 16ZM362.057 365.77C358.791 367.275 355.369 367.998 352.01 367.998C342.932 367.998 334.262 362.818 330.199 353.996L318.172 327.813H193.828L181.803 353.996C176.225 366.084 162.037 371.357 149.945 365.77C137.914 360.213 132.664 345.865 138.211 333.777L234.205 124.809C242.049 107.73 269.953 107.73 277.797 124.809L373.789 333.777C379.336 345.865 374.086 360.213 362.057 365.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleA);
export default __webpack_public_path__ + "static/media/circle-a.1e856e4a3021d453c6d971f8bd563526.svg";
export { ForwardRef as ReactComponent };